import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../list/actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import store from '../../../store';

function* deletePromotion({ payload: { id, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.promotions.remove, id });

    dispatch(listActions.getPromotionsRequest({ curr_page: getState().getPromotions.curr_page }));

    onSuccess && onSuccess();
    yield put(actions.deletePromotionDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deletePromotionFailed,
      endpoint: api.promotions.remove.url
    });
  }
}

export const deletePromotionSaga = takeEvery(types.DELETE_PROMOTION_REQUEST, deletePromotion);